import type { StandardsView } from "@buildpy/core/views/g5a/standards";
import EmptyState from "@buildpy/ui/empty-state";

import { formatDate } from "@buildpy/core/lib/format";
import StandardsList from "@/modules/process-standard/ui/standards-list";
import StandardsShell from "@/modules/process-standard/ui/standards-shell";

// 공정 표준 — KR 최신 판의 항목을 공정별로 묶고 항목마다 시공법 글(고치기)·숫자 제안을 붙인다.
const Page = ({ data }: { data: StandardsView }) => {
  const { version, items, articles } = data;
  const meta = version ? `${version.country} · ${version.label} (판 ${version.version}) · 게시 ${formatDate(version.published_at)}` : undefined;

  return (
    <StandardsShell meta={meta} tab="items">
      {version && items.length > 0 ? (
        <StandardsList articles={articles} items={items} versionId={version.id} />
      ) : (
        <EmptyState>아직 게시된 공정 표준 판이 없습니다.</EmptyState>
      )}
    </StandardsShell>
  );
};

export default Page;
